import {
  BackgroundJobQueueDto,
  BackgroundJobServerDto,
} from 'src/api/FiretrolApiClient';

export interface IServerQueueRow {
  key: string;
  queue: string;
  waiting: number;
  fetched: number;
  serverName?: string;
  workersCount?: number;
  startedAt?: Date;
  heartbeat?: Date;
}

/**
 * Hangfire only reports a queue once it holds enqueued jobs, so an idle configured queue exists
 * solely on the server records. A queue no server listens on is reported without a server.
 */
export const buildServerQueueRows = (
  servers: BackgroundJobServerDto[],
  queues: BackgroundJobQueueDto[],
): IServerQueueRow[] => {
  const reported = new Map(queues.map((queue) => [queue.name, queue]));
  const rows: IServerQueueRow[] = [];
  const listened = new Set<string>();

  for (const server of servers) {
    for (const name of server.queues) {
      listened.add(name);
      rows.push({
        key: `${name}\u0000${server.name}`,
        queue: name,
        waiting: reported.get(name)?.length ?? 0,
        fetched: reported.get(name)?.fetched ?? 0,
        serverName: server.name,
        workersCount: server.workersCount,
        startedAt: server.startedAt,
        heartbeat: server.heartbeat,
      });
    }
  }

  for (const queue of queues) {
    if (listened.has(queue.name)) continue;
    rows.push({
      key: `${queue.name}\u0000`,
      queue: queue.name,
      waiting: queue.length,
      fetched: queue.fetched,
    });
  }

  return rows.sort(
    (left, right) =>
      left.queue.localeCompare(right.queue) ||
      (left.serverName ?? '').localeCompare(right.serverName ?? ''),
  );
};
